var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-field',{attrs:{"label":"Project Title"}},[_c('b-input',{attrs:{"value":_vm.value},on:{"input":function (value) { return _vm.$emit('input', value); }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }